import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/d2c-sales-tool/src/app/global-error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UrqlBrowserClientProvider"] */ "/vercel/path0/apps/d2c-sales-tool/src/graphql/UrqlBrowserClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/d2c-sales-tool/src/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/d2c-sales-tool/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BugSnagErrorBoundary"] */ "/vercel/path0/apps/d2c-sales-tool/src/utils/bugsnagUtils.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.26_@babel+core@7.24.7_@playwright+test@1.44.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/script.js");
